/**
 * OrbDocReferenceOperatorsENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocReferenceOperatorsENDocScreen
 */

import { useOrbDocReferenceOperatorsENDocScreenLogic } from '@/hooks/traits/useOrbDocReferenceOperatorsENDocScreenLogic';
import type { OrbDocReferenceOperatorsENDocScreenConfig } from '@/hooks/traits/useOrbDocReferenceOperatorsENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocReferenceOperatorsENDocView as OrbDocReferenceOperatorsENDocViewEntity } from '@app/shared';
import { OrbDocReferenceOperatorsENDocBodyView } from '@/components/traits/OrbDocReferenceOperatorsENDocBodyView';
import { OrbDocReferenceOperatorsENDocFooterView } from '@/components/traits/OrbDocReferenceOperatorsENDocFooterView';
import { OrbDocReferenceOperatorsENDocHeaderView } from '@/components/traits/OrbDocReferenceOperatorsENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocReferenceOperatorsENDocScreenViewProps {
  config?: Partial<OrbDocReferenceOperatorsENDocScreenConfig>;
}

export function OrbDocReferenceOperatorsENDocScreenView({ config: propsConfig }: OrbDocReferenceOperatorsENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocReferenceOperatorsENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocReferenceOperatorsENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocReferenceOperatorsEN" trait="OrbDocReferenceOperatorsENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocReferenceOperatorsENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocReferenceOperatorsENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocReferenceOperatorsENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocReferenceOperatorsENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocReferenceOperatorsENDocScreenView;
